import { ContentService, ContentTitleModel } from "@/services/content";
import { store } from "commonui";
import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";

const filterTitlesByUnitOptionally = (titles: ContentTitleModel[], unitId?: number): ContentTitleModel[] => {
	if (!unitId) {
		return titles;
	}
	return titles.filter((title) => title.unitId === unitId);
};

@Module({ namespaced: true, dynamic: true, store: store, name: "ContentTitle" })
class ContentTitleState extends VuexModule {
	public titles: { [key: string]: ContentTitleModel[]; } = {};

	@Action
	public async getTitles(params: { versionGroupId: string; unitId?: number; }): Promise<ContentTitleModel[]> {
		const { versionGroupId, unitId } = params;
		if (this.titles[versionGroupId]?.length) {
			return filterTitlesByUnitOptionally(this.titles[versionGroupId], unitId);
		}
		const titles = await ContentService.getCMTitles(versionGroupId);
		this.setTitles({ titles, versionGroupId });

		return filterTitlesByUnitOptionally(titles, unitId);
	}

	@Mutation
	private setTitles(data: { titles: ContentTitleModel[]; versionGroupId: string; }) {
		this.titles = { ...this.titles, [data.versionGroupId]: data.titles };
	}
}

export const ContentTitleModule = getModule(ContentTitleState);
